import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { object, number } from "prop-types";

import StoryCard2 from "../../molecules/story-card2";
import StoryCard5 from "../../molecules/story-card5";
import StoryCard14 from "../../molecules/story-card14";
import StoryCard13 from "../../molecules/story-card13";
import CollectionTitleHeader from "../../molecules/collection-title-header";

import Separator from "../../atoms/separator";
import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";

import "./two-col-one-big-nine-small-cards.m.css";

const TwoColOneBigNineSmallCards = ({ collection, index }) => {
  const [isMobile, setMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }

    setTimeout(() => {
      setIsVisible(true);
    }, 100);
  }, []);
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  if (!stories.length) {
    return null;
  }

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };
  const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);
  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  return (
    <>
      <div styleName="container">
        <CollectionTitleHeader collection={collection} index={index} />
        <div styleName="wrapper">
          {isVisible && (
            <>
              <div styleName="stories-wrapper" className="hide-mobile">
                <div styleName="col1-container">
                  {stories?.slice(0, 1).map((story, index) => (
                    <div key={index} styleName="col1-top-story">
                      <StoryCard14 story={story} />
                    </div>
                  ))}

                  <div styleName="col1-bottom">
                    <div styleName="col1-bottom-stories">
                      {stories?.slice(1, 4).map((item, index) => (
                        <StoryCard2 story={item} key={index} />
                      ))}
                    </div>
                    <div styleName="col1-bottom-stories">
                      {stories?.slice(4, 7).map((item, index) => (
                        <StoryCard2 story={item} key={index} />
                      ))}
                    </div>
                  </div>
                </div>
                <div styleName="item">
                  {stories?.slice(7, desktopAdUnitId ? 9 : 10).map((item, index) => (
                    <>
                      <StoryCard2 story={item} key={index} />
                      {index === 1 && !isMobile && desktopAdUnitId ? (
                        <div styleName="ad-wrapper">
                          <AdContainer
                            AdClassName="standard-336x280"
                            id="div-gpt-ad-1680156228599-0"
                            desktop={desktopAdUnitId}
                          />
                        </div>
                      ) : null}
                    </>
                  ))}
                </div>
              </div>
            </>
          )}
          {isMobile ? (
            <div styleName="stories-wrapper-mobile" className="hide-desktop">
              <div styleName="top-story-mob">
                {stories?.slice(0, 1).map((story, index) => (
                  <StoryCard5 story={story} key={index} />
                ))}
              </div>
              <div styleName="rest-stories-mob">
                {stories?.slice(1, 11).map((item, index) => (
                  <>
                    <StoryCard13 story={item} key={index} />
                    {index === 1 ? <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} /> : null}
                    {index === 5 ? <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} /> : null}
                    {index === 9 ? <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} /> : null}
                  </>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {isVisible && <Separator />}
    </>
  );
};

TwoColOneBigNineSmallCards.propTypes = {
  collection: object,
  index: number
};

export default TwoColOneBigNineSmallCards;
